import React from "react";
import { createFromIconfontCN } from '@ant-design/icons';
import colors from "./style/less/colors";
var PUBLIC_URL = process.env.PUBLIC_URL;
var IconFont = createFromIconfontCN({
    extraCommonProps: {
    // style: {
    //   fontSize: "14px",
    //   color: "rgba(129, 135, 147, 1)"
    // }
    },
    scriptUrl: PUBLIC_URL ? PUBLIC_URL + "/iconfont.js" : "/iconfont.js" // '//at.alicdn.com/t/font_1717591_5fs7ttlpnm6.js',
});
export default IconFont;
export var IconFresh = React.createElement(IconFont, { type: "iconjs_ic_break" });
export var IconSearch = React.createElement(IconFont, { type: "iconquanjusousuo", style: { fontSize: 16 } });
export var IconAppointMeeting = React.createElement(IconFont, { type: "iconapp_btn_joymeeting_video" });
export var IconWebAddres = React.createElement(IconFont, { type: "iconpc_ic_webaddres_kuangjia" });
export var IconHoutai = React.createElement(IconFont, { type: "iconhoutai" });
export var IconCloseEye = React.createElement(IconFont, { type: "iconzw_web_eye_closed" });
export var IconTitleRight = React.createElement(IconFont, { type: "iconic_joyday_title_dropdown" });
export var IconChat = React.createElement(IconFont, { type: "iconic_chat" });
export var IconMultimedia = React.createElement(IconFont, { type: "iconapp_btn_joymeeting_video" }); // TODO: 临时使用该图标
export var IconShare = React.createElement(IconFont, { type: "iconapp_btn_peopleshare" });
export var IconJoyspace = React.createElement(IconFont, { type: "iconapp_ic_bardoc" });
export var IconCalendar = React.createElement(IconFont, { type: "iconic_day" });
export var IconWork = React.createElement(IconFont, { type: "iconbacklog" });
export var IconThirdApp = React.createElement(IconFont, { type: "iconapp_tabbar_application" });
export var IconHomeApp = React.createElement(IconFont, { type: "iconshouye" });
export var IconClose = React.createElement(IconFont, { type: "iconwin_Close" });
export var IconRefresh = React.createElement(IconFont, { type: "iconbtn_reduction" });
export var IconEBook = React.createElement(IconFont, { type: "iconapp_btn_addressbook" });
export var IconMail = React.createElement(IconFont, { type: "iconapp_btn_pc_mail" });
export var IconSetup = React.createElement(IconFont, { type: "iconapp_btn_Setup" });
export var IconArrowRight = React.createElement(IconFont, { type: "iconapp_ic_arrow_right" });
export var IconArrowRightLayout = React.createElement(IconFont, { type: "iconFrame6" });
export var IconMore = React.createElement(IconFont, { type: "iconwin_more" });
export var IconEdit = React.createElement(IconFont, { type: "iconapp_btn_edit" });
export var IconRdit = React.createElement(IconFont, { type: "iconkefu", style: { fontSize: "20px", color: 'rgba(252, 167, 0, 1)' } });
export var IconFailure = React.createElement(IconFont, { type: "iconic_failure" });
export var IconSet = React.createElement(IconFont, { type: "iconxitongshezhi", style: { fontSize: "20px", color: 'rgba(69, 0, 228, 1)' } });
export var IconExit = React.createElement(IconFont, { type: "icontuichudenglu", style: { fontSize: "20px", color: 'rgba(0, 188, 182, 1)' } });
export var IconManager = React.createElement(IconFont, { type: "iconiconbtn_manager" });
export var IconAdd = React.createElement(IconFont, { type: "iconbtn_add" });
export var IconGroup = React.createElement(IconFont, { type: "icona-statequnzu", style: { fontSize: "20px", color: "rgba(129, 135, 147, 1)" } });
export var IconMeeting = React.createElement(IconFont, { type: "iconapp_ic_Joymeeting" });
export var IconJoinMeeting = React.createElement(IconFont, { type: "iconapp_ic_join_meeting" });
export var IconCopyBtn = React.createElement(IconFont, { type: "iconweb_btn_copy" });
export var IconZhuanban = React.createElement(IconFont, { className: "create-zhuanban-icon", type: "iconzw_app_project" });
export var IconMute = React.createElement(IconFont, { type: "iconmute" });
export var IconDocHome = React.createElement(IconFont, { type: "iconapp_ic_dochome" });
export var IconMyDoc = React.createElement(IconFont, { type: "iconapp_ic_mydoc" });
export var IconMobilePhone = React.createElement(IconFont, { type: "iconic_mobilephone" });
// 收藏
export var IconKeep = React.createElement(IconFont, { type: "iconic_yipingfen" });
export var IconCancelKeep = React.createElement(IconFont, { type: "iconic_pingfen" });
// 圆加号
export var IconAddApp = React.createElement(IconFont, { type: "iconapp_btn_add" });
// 圆取消
export var IconCircleClose = React.createElement(IconFont, { type: "iconjs_ic_error" });
// 搜索
// export const IconSearch = <IconFont type="iconic_search" />;
export var IconRemind3 = React.createElement(IconFont, { type: "iconzw_app_remind3" }); // 催办小铃铛图标
// export const IconlogDown = <IconFont type="iconlog_down" />;
export var IconDefualtOrg = (React.createElement("div", { style: {
        color: "#fff",
        backgroundColor: "" + colors.primary2,
        borderRadius: 8,
        height: 36,
        width: 36,
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
    } },
    React.createElement(IconFont, { type: "iconapp_btn_cha" })));
export var IconDefualtWorkLine = (React.createElement("div", { style: {
        color: "#fff",
        backgroundColor: "" + colors.primary2,
        borderRadius: 8,
        height: 36,
        width: 36,
        display: "flex",
        alignItems: "center",
        justifyContent: "center"
    } },
    React.createElement(IconFont, { type: "icontiaoxian2", style: { fontSize: 18 } })));
export var IconRight = React.createElement(IconFont, { type: "iconapp_ic_arrow_right" });
export var IconArrowLeft = React.createElement(IconFont, { type: "iconwin_left" });
export var IconJoyMeetingGroup = React.createElement(IconFont, { type: "icona-statelianxiren", style: { fontSize: "20px", color: "rgba(129, 135, 147, 1)" } });
export var IconTopUp = React.createElement(IconFont, { type: "iconapp_btn_top_up" });
export var IconSwitch = React.createElement(IconFont, { type: "iconlog_switch" });
export var IconApplicationShop = React.createElement(IconFont, { type: "iconapp_application_shop" });
export var getIconFromString = function (type) { return React.createElement(IconFont, { type: type }); };
export var IconicPcDongaoAdd = React.createElement(IconFont, { type: "iconic_pc_dongao_add" });
export var IconbtnTopUp = React.createElement(IconFont, { type: "iconbtn_top_up" });
export var IconbtnTopDown = React.createElement(IconFont, { type: "iconbtn_top_down" });
export var IconScale = React.createElement(IconFont, { type: "icon_scale" });
export var IconClearcCache = React.createElement(IconFont, { type: "icon_clear_cache" });
export var IconWangluo = React.createElement(IconFont, { type: "iconwangluo", style: { fontSize: "20px", color: 'rgba(0, 91, 249, 1)' } });
export var IconErWeiMa = React.createElement(IconFont, { type: "iconerweima", style: { fontSize: "20px", color: 'rgba(144, 0, 216, 1)' } });
export var IconAddWorkStatus = React.createElement(React.Fragment, null,
    React.createElement(IconFont, { type: "icontianjia1" }),
    "\u72B6\u6001");
//# sourceMappingURL=IconFontV2.js.map